<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <app-ag-grid gridId="unapplyItemDetailGrid" [gridOptions]="itdGridOptions" [rowData]="itemDetails"> </app-ag-grid>
  <ng-template #unapplyCell let-row>
    <button pButton type="button" class="p-button-text p-button-sm" (click)="unapplyItemDetail(row)">Unapply</button>
  </ng-template>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button (click)="unapplyAll()" pButton type="button" class="p-button-raised">Unapply All</button>
    <button (click)="close()" pButton type="button" class="p-button-raised">Close</button>
  </div>
</ng-template>
